export default "__VITE_ASSET__BhWjtWXW__"